import { CountryDictOption } from 'api/dict/params';
import { FeedRequestFilter, FeedRegistryFilter } from './types';

const getDictValue = (isResident: boolean, value?: CountryDictOption): string | undefined => {
  if (!value) {
    return undefined;
  }
  if (isResident) {
    return value.guid === 'true' || value.guid === 'false' ? value.guid : undefined;
  }
  return value.guid === 'true' || value.guid === 'false' ? undefined : value.guid;
};

const getCountryListValue = (isResident: boolean, value?: CountryDictOption[]) => {
  if (!value || value.length === 0) {
    return {
      isResident: undefined,
      countryList: undefined,
    };
  }

  const valueGuid = value.filter((item) => item.guid === 'true' || item.guid === 'false')[0]?.guid;

  if (isResident && valueGuid) {
    return {
      isResident: valueGuid === 'true' || valueGuid === 'false' ? valueGuid : undefined,
      countryList: undefined,
    };
  }

  if (!isResident && valueGuid) {
    return {
      isResident: valueGuid === 'true' || valueGuid === 'false' ? undefined : valueGuid,
      countryList: undefined,
    };
  }

  return {
    isResident: undefined,
    countryList: value.map((item) => item.guid),
  };
};

export const normalizeRequestFilters = ({
  vendorResident,
  sendingPeriod,
  vendor,
  name,
  businessEntitySearchCriteria,
  ...values
}: FeedRequestFilter) => ({
  ...values,
  requestDateFrom: sendingPeriod?.beginDate,
  requestDateTo: sendingPeriod?.endDate,
  vendorResident: getDictValue(true, vendorResident),
  vendorCountryList: getDictValue(false, vendorResident)
    ? [getDictValue(false, vendorResident)]
    : undefined,
  vendor: vendor?.name,
  name: name?.name,
  businessEntitySearchCriteria: businessEntitySearchCriteria?.value,
});

export const normalizeRegistryFilters = ({
  producerCountryList,
  vendorCountryList,
  producerLocationCountryList,
  haveInstruction,
  presenceGMO,
  feedAdditiveTypeCodeList,
  feedAdditiveKindCodeList,
  animalSpeciesList,
  startValidityDate,
  requestDate,
  name,
  vendor,
  producer,
  businessEntitySearchCriteria,
  ...values
}: FeedRegistryFilter) => {
  const producerValues = getCountryListValue(true, producerCountryList);
  const producerLocationValues = getCountryListValue(true, producerLocationCountryList);
  const vendorValues = getCountryListValue(true, vendorCountryList);
  return {
    ...values,
    haveInstruction: haveInstruction?.value,
    producerResident: producerValues.isResident,
    vendorResident: vendorValues.isResident,
    producerLocationResident: producerLocationValues.isResident,
    presenceGMO: presenceGMO?.value,
    startValidityDateFrom: startValidityDate?.beginDate,
    startValidityDateTo: startValidityDate?.endDate,
    requestDateFrom: requestDate?.beginDate,
    requestDateTo: requestDate?.endDate,
    name: name?.name,
    vendor: vendor?.name,
    producer: producer?.name,
    producerLocationCountryList: producerLocationValues.countryList,
    vendorCountryList: vendorValues.countryList,
    producerCountryList: producerValues.countryList,
    animalSpeciesList: animalSpeciesList?.map((item) => item?.id),
    feedAdditiveTypeCodeList: feedAdditiveTypeCodeList?.map((item) => item?.code),
    feedAdditiveKindCodeList: feedAdditiveKindCodeList?.map((item) => item?.code),
    businessEntitySearchCriteria: businessEntitySearchCriteria?.value,
  };
};
